import styled from "@emotion/styled";

import MorningStudioLogo from "~/components/article/article-render/morning-studio-article/header/morning-studio-logo.svg";
import { ArticleShareWidget } from "~/components/article/article-share-widget";
import { ArticleSponsor } from "~/components/article/article-sponsor";
import { setFullViewportWidthStyles } from "~/lib/styles";

export const SubheaderContainer = styled.div`
  ${setFullViewportWidthStyles()}

  position: absolute;
  inset-block-start: 0;
  z-index: 2;

  display: none;

  block-size: 55px;

  background-color: rgba(0, 0, 0, 0.6);
  ${props => props.theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  block-size: 100%;
  max-inline-size: 1560px;
  margin-inline: auto;
  padding-inline: 40px;

  ${props => props.theme.breakpoints.up("xLargeDesktop")} {
    padding-inline: 12px;
  }
`;

export const StyledArticleSponsor = styled(ArticleSponsor)`
  flex: 1;
`;

export const StyledMorningStudioLogo = styled(MorningStudioLogo)`
  flex: 1;
`;

export const StyledArticleShareWidget = styled(ArticleShareWidget)`
  flex: 1;
  align-items: flex-end;
`;
